<div class="notification-bell" (click)="openNotificationModal()">
  <i class="fas fa-bell"></i>
  <span *ngIf="(unreadCount$ | async) > 0" class="badge">
    {{ unreadCount$ | async }}
  </span>
</div>
